<template>
  <main class="project__container" @wheel='fadeScroll' v-touch:moving='fadeScroll'>
    <div class="transitionState">
      <div class="img__container">
      </div>
      <div class="scroll">
        <p>scroll</p>
        <div class="svg">
          <svg width="24px" height="32px" viewBox="0 0 24 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.2">
              <g transform="translate(-708.000000, -868.000000)" fill="#FFFFFF">
                <g id="scroll" transform="translate(695.000000, 835.000000)">
                  <g transform="translate(13.000000, 33.000000)">
                    <rect x="0" y="0" width="3.46229508" height="4.31803279"></rect>
                    <rect x="5.13442623" y="0" width="13.7311475" height="32"></rect>
                    <rect x="0" y="5.99016393" width="3.46229508" height="5.17377049"></rect>
                    <rect x="0" y="12.8360656" width="3.46229508" height="5.17377049"></rect>
                    <rect x="0" y="19.68" width="3.46229508" height="5.17377049"></rect>
                    <rect x="-2.77555756e-13" y="26.52" width="3.46229508" height="5.31803279"></rect>
                    <rect x="20.5377049" y="5.99016393" width="3.46229508" height="5.17377049"></rect>
                    <rect x="20.5377049" y="26.52" width="3.46229508" height="5.31803279"></rect>
                    <rect x="20.5377049" y="0" width="3.46229508" height="4.31803279"></rect>
                    <rect x="20.5377049" y="12.8360656" width="3.46229508" height="5.17377049"></rect>
                    <rect x="20.5377049" y="19.68" width="3.46229508" height="5.17377049"></rect>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
    <section class="description">
      <div class="clapperboard">
        <div class="subtitle">Clapperboard</div>
        <div class="clapperboard__container">
          <div class="prod"><span>Prod.</span>{{ projects[id].title }}</div>
          <div class="three__numbers">
            <div>
              <p class="number__title">{{ projects[id].clapperboard.number1[0] }}</p>
              <p class="number">{{ projects[id].clapperboard.number1[1] }}</p>
            </div>
            <div>
              <p class="number__title">{{ projects[id].clapperboard.number2[0] }}</p>
              <p class="number">{{ projects[id].clapperboard.number2[1] }}</p>
            </div>
            <div>
              <p class="number__title">{{ projects[id].clapperboard.number3[0] }}</p>
              <p class="number">{{ projects[id].clapperboard.number3[1] }}</p>
            </div>
          </div>
          <div class="client"><span>Client:</span>{{ projects[id].clapperboard.client }}</div>
          <div class="role"><span>Role:</span>{{ projects[id].clapperboard.role }}</div>
          <div class="date"><span>Date:</span>{{ projects[id].clapperboard.date }}</div>
        </div>
      </div>
      <div class="synopsis">
        <div class="subtitle">Synopsis</div>
        <div class="paragraph">{{ projects[id].synopsis }}</div>
        <div class="link paragraph" v-if="projects[id].link[0] !== ''"><a :href="projects[id].link[1]" rel="noreferrer" target="_blank">{{projects[id].link[0]}}</a></div>
      </div>
    </section>
    <section class="images">
      <div :class="'image ' + image[2] + ' ' + image[3]" v-for="image in projects[id].images" :key="image.id">
        <div class="subtitle">{{ image[0] }}</div>
        <img class="js-lazy-image" src="" :data-src="image[1]" :alt="image[0]" v-if="image[2] === 'img' || image[2] === 'gif'">
        <video class="js-lazy-image" src="" :data-src="image[1]" autoplay muted loop playsinline v-else @mouseover="addAudio" @mouseleave="$event.target.muted = true"></video>
      </div>
    </section>
    <section class="credits" v-if="projects[id].credits">
      <div class="subtitle">Credits</div>
      <div>
        <div class="credit__name">
          <p v-for="credit in projects[id].credits" :key="credit.id">{{ credit[0] }}</p>
        </div>
        <div class="credit__role">
          <p v-for="credit in projects[id].credits" :key="credit.id">{{ credit[1] }}</p>
        </div>
      </div>
    </section>
    <footer class="post__credit">
      <div class="post__credit__container none">
      </div>
      <div class="post__credit__keep hide">Keep scrolling to get back to chapter selection</div>
    </footer>
  </main>
</template>

<script>
import Projects from '@/assets/js/projects.json'
const { detect } = require('detect-browser')
const browser = detect()

export default {
  data () {
    return {
      id: 0,
      nextId: 0,
      projects: Projects,
      observer: '',
      touch: false,
      touched: false,
      pageHeight: 0
    }
  },

  mounted () {
    // get value
    let imgContainer = document.querySelector('.scene')

    // set new values
    this.id = parseInt(this.$route.params.id)
    this.nextId = (this.id + 1) % 5
    document.querySelector('body').style.overflowY = 'scroll'
    imgContainer.classList.add('scene__project__transition')

    this.$nextTick(() => { this.loadImg() })
    document.querySelector('.close__project').addEventListener('click', () => { this.backHome(true) })
  },

  methods: {
    fadeScroll (e) {
      let scroll = document.querySelector('.scroll')

      if (window.scrollY > 30) {
        scroll.style.opacity = 0
      } else {
        scroll.style.opacity = 1
      }
      if (window.scrollY + window.innerHeight === document.querySelector('.project__container').clientHeight) {
        if (this.touch === true && this.touched === false) {
          e.preventDefault()
          e.stopPropagation()
          this.touched = true
          this.$emit('nextChapter', this.id)
          let imgContainer = document.querySelector('.scene')
          imgContainer.style.transition = 'all 0s'
          imgContainer.classList.remove('scene__project__transition')
          this.$router.push('/')
        } else {
          document.querySelector('.post__credit__keep').classList.remove('hide')
          document.querySelector('.post__credit__container').classList.remove('none')
          this.pageHeight = document.querySelector('.project__container').clientHeight - document.querySelector('.post__credit__container').clientHeight
          this.touch = true
        }
      } else if (window.scrollY + window.innerHeight < this.pageHeight && this.touch === true) {
        document.querySelector('.post__credit__keep').classList.add('hide')
        document.querySelector('.post__credit__container').classList.add('none')
        this.touch = false
      }
    },

    imagesApparition () {
      const images = document.querySelectorAll('.js-lazy-image')
      const config = {
        rootMargin: '30px 0px',
        threshold: 0.01
      }
      this.observer = new IntersectionObserver(this.onIntersection, config)
      images.forEach(image => {
        image.style.opacity = 0
        image.style.transform = 'scale(0.97)'
        this.observer.observe(image)
      })
    },

    onIntersection (entries) {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          this.observer.unobserve(entry.target)
          entry.target.style.opacity = 1
          entry.target.style.transform = 'scale(1)'
        }
      })
    },

    backHome (cross) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      let imgContainer = document.querySelector('.scene')
      imgContainer.classList.remove('scene__project__transition')
      this.$emit('fromProject', this.id)

      if (cross === true) {
        this.$router.push('/')
      }
    },

    loadImg () {
      let imgs = document.querySelectorAll('.js-lazy-image')
      for (let i = 0; i < imgs.length; i++) {
        imgs[i].setAttribute('src', imgs[i].dataset.src)
      }
      if (browser.name !== 'safari' && browser.name !== 'ios') this.imagesApparition()
    },

    addAudio (e) {
      if (browser.name !== 'safari' && browser.name !== 'io') {
        e.target.muted = false
      }
    }
  },

  beforeRouteLeave (to, from, next) {
    if (to.name === 'Home' && this.touched === false) {
      this.backHome(false)
      setTimeout(() => {
        next()
      }, 1000)
    } else {
      next()
    }
  },

  destroyed () {
    let imgContainer = document.querySelector('.scene')
    imgContainer.classList.remove('scene__project__transition')
  }
}
</script>

<style lang="scss" scoped>
// responsive
$small-phone:325px;
$phone:640px;
$tablet: 768px;
$desktop: 1024px;
$large: 1680px;

.project__container
{
  position: relative;
  z-index: 2;

  .transitionState
  {
    width: 100vw;
    height: 100vh;
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;

    .img__container
    {
      height: calc(100vh/1.5);
      overflow: hidden;
      border-radius: calc(100vh/15);
      width: 600px;
      display: flex;
      justify-content: center;
      transition: width 1s cubic-bezier(0.86,-0.06, 0.23, 0.99);

      @media screen and (max-width:$phone) and (orientation: portrait) {
        width: calc(100vw - 80px);
        height: calc(100vw - 80px);
      }
    }

    .scroll
    {
      position: absolute;
      bottom: 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      transition: 0.4s ease;

      @media screen and (max-width: $phone)
      {
        bottom: 12%;
      }

      p
      {
        font-family: "DIN Pro";
        font-size: 20px;
        color: rgba(255,255,255,0.30);
        margin-bottom: 8px;
      }

      .svg
      {
        overflow: hidden;

        svg
        {
          animation: scrollAnimation 2s cubic-bezier(0.86,-0.06, 0.23, 0.99) infinite;
        }

        @keyframes scrollAnimation
        {
          0% {
            transform: translateY(48px)
          }

          100% {
            transform: translateY(-48px)
          }
        }
      }
    }

  }

  .description
  {
    width: calc(100vw - 140px);
    display: grid;
    grid-template-columns: 1fr 20px 1fr 20px 1fr 20px 1fr 20px 1fr 20px 1fr 20px 1fr 20px 1fr 20px 1fr 20px 1fr 20px 1fr 20px 1fr;
    margin: 200px auto 140px auto;

    @media screen and (max-width:$phone) and (orientation: portrait) {
      width: calc(100vw - 48px);
      display: flex;
      flex-direction: column;
      grid-template-columns: none;
      margin: 48px auto 48px auto;
    }

    @media screen and (min-width:2560px) {
      width: calc(100vw - 480px);
    }

    .clapperboard
    {
      grid-column-start: 1;
      grid-column-end: 10;

      @media screen and (max-width:$phone) and (orientation: portrait) {
        grid-column-start: none;
        grid-column-end: none;
        margin-bottom: 40px;
      }

      @media screen and (min-width:$large) {
        grid-column-end: 8;
      }

      .clapperboard__container
      {
        width: 100%;

        div
        {
          font-family: "DIN Pro";
          font-size: 18px;
          color: #FFFFFF;

          @media screen and (max-width:$phone) and (orientation: portrait) {
            font-size: 14px;
          }

          span
          {
            font-weight: 500;
            font-style: italic;
            margin-right: 24px;

            @media screen and (max-width:$phone) and (orientation: portrait) {
              margin-right: 8px;
            }
          }
        }

        .prod, .role
        {
          border-bottom: 1px solid rgba(255,255,255,0.80);
          padding-bottom: 8px;
        }

        .client
        {
          padding: 8px 0px;
          border-top: 1px solid rgba(255,255,255,0.80);
        }

        .date
        {
          margin-top: 8px;
        }

        .three__numbers
        {
          display: flex;
          justify-content: space-between;

          div
          {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 33%;
            border-right: 1px solid rgba(255,255,255,0.80);

            .number__title
            {
              font-family: "DIN Pro";
              font-weight: 500;
              font-style: italic;
              font-size: 18px;
              color: #FFFFFF;
              margin: 8px 0px;
              text-transform: uppercase;

              @media screen and (max-width:$phone) and (orientation: portrait) {
                font-size: 14px;
              }

              @media screen and (max-width:$small-phone) and (orientation: portrait) {
                font-size: 12px;
              }
            }

            .number
            {
              font-family: "DIN Pro";
              font-weight: 500;
              font-size: 40px;
              color: #FFFFFF;
              margin-bottom: 8px;

              @media screen and (max-width:$phone) and (orientation: portrait) {
                font-size: 32px;
              }

              @media screen and (max-width:$small-phone) and (orientation: portrait) {
                font-size: 24px;
              }
            }

            &:last-child
            {
              border-right: none;
            }
          }
        }
      }
    }

    .synopsis
    {
      grid-column-start: 13;
      grid-column-end: 24;

      @media screen and (min-width:$large) {
        grid-column-end: 22;
      }
    }

    .link
    {
      margin-top: 24px;
      opacity: 0.6;
      transition: 0.4s ease;

      a
      {
        color: #fff;
      }

      a:visited
      {
        color: #fff;
      }

      &:hover
      {
        opacity: 1;
      }
    }

    .subtitle
    {
      margin-bottom: 32px;

      @media screen and (max-width:$phone) and (orientation: portrait) {
        margin-bottom: 8px;
      }
    }
  }

  .images
  {
    display: grid;
    grid-template-columns: 1fr calc(100vw - 140px) 1fr;
    margin: 160px auto 0px auto;

    @media screen and (max-width:$phone) and (orientation: portrait) {
      grid-template-columns: 1fr calc(100vw - 48px) 1fr;
      margin: 0px auto 0px auto;
    }

    @media screen and (min-width:2560px) {
      grid-template-columns: 1fr calc(100vw - 480px) 1fr;
    }

    .image
    {
      grid-column-start: 2;
      grid-column-end: 3;
      margin-bottom:200px;

      @media screen and (max-width:$phone) and (orientation: portrait) {
        margin-bottom: 24px;
      }

      img
      {
        width: 100%;
        height: auto;
        margin: 16px auto 0px auto;
        display: block;
        transition: all 0.6s cubic-bezier(0.44,-0.01, 0.61, 0.97);
      }

      &.full
      {
        grid-column-start: 1;
        grid-column-end: 4;
      }

      &.video, &.gif
      {
        grid-column-start: 1;
        grid-column-end: 4;
        background-color: rgba(255,255,255,0.10);
        padding: 50px 0px;
        display: grid;
        grid-template-columns: 1fr 80% 1fr;

        video, img
        {
          grid-column-start: 2;
          grid-column-end: 3;
          display: block;
          margin: 0px auto 0px auto;
          width: 100%;
          height: auto;
          transition: all 0.6s cubic-bezier(0.44,-0.01, 0.61, 0.97);
        }

        .subtitle
        {
          grid-column-start: 2;
          grid-column-end: 3;
          margin-bottom: 16px;
        }
      }
    }
  }

  .credits
  {
    width: calc(100vw - 140px);
    margin: 0px auto 0px auto;

    @media screen and (max-width:$phone) and (orientation: portrait) {
      width: calc(100vw - 48px);
      margin: 48px auto 0px auto;
    }

    @media screen and (min-width:2560px) {
      width: calc(100vw - 480px);
    }

    .subtitle
    {
      margin-bottom: 32px;

      @media screen and (max-width:$phone) and (orientation: portrait) {
        margin-bottom: 16px;
      }
    }

    div
    {
      display: flex;

      .credit__name
      {
        display: flex;
        flex-direction: column;
        margin-right: 24px;

        @media screen and (max-width:$phone) and (orientation: portrait) {
          margin-right: 16px;
        }

        @media screen and (max-width:$small-phone) and (orientation: portrait) {
          margin-right: 8px;
        }

        p
        {
          font-family: "DIN Pro";
          font-weight: 600;
          font-size: 16px;
          color: #FFFFFF;
          text-transform: uppercase;
          margin-bottom: 16px;

          @media screen and (max-width:$phone) and (orientation: portrait) {
            font-size: 14px;
            white-space: nowrap;
            margin-bottom: 24px;
          }

          @media screen and (max-width:$small-phone) and (orientation: portrait) {
            font-size: 12px;
            margin-bottom: 24px;
          }
        }
      }

      .credit__role
      {
        display: flex;
        flex-direction: column;

        p
        {
          font-family: "DIN Pro";
          font-size: 16px;
          color: #FFFFFF;
          height: 19px;
          margin-bottom: 16px;

          @media screen and (max-width:$phone) and (orientation: portrait) {
            font-size: 14px;
            height: 17px;
            margin-bottom: 24px;
          }

          @media screen and (max-width:$small-phone) and (orientation: portrait) {
            font-size: 12px;
            height: 14px;
            margin-bottom: 24px;
          }
        }
      }
    }
  }

  .post__credit
  {
    margin-top: 120px;
    position: relative;

    @media screen and (max-width:$phone) and (orientation: portrait) {
      margin-top: 40px;
    }

    .subtitle
    {
      width: calc(100vw - 140px);
      margin: 0px auto 16px auto;

      @media screen and (max-width:$phone) and (orientation: portrait) {
        width: calc(100vw - 48px);
      }
    }

    &__keep
    {
      width: 100%;
      font-family: "Din Pro";
      font-size: 20px;
      text-align: center;
      color: #fff;
      opacity: 0.5;
      position: fixed;
      bottom: 40px;
      transition: 1s ease;

      @media screen and (max-width:$phone)
      {
        font-size: 14px;
      }

      &.hide
      {
        opacity: 0;
      }
    }

    &__container
    {
      height: 100vh;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Project.vue